export default __webpack_public_path__ + "static/media/company_4.38835c4f.jpg";